import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { ElementRef, Component, Inject, HostBinding, Input, EventEmitter, Output, HostListener, NgModule } from '@angular/core';
import { FadvBaseComponent, Forward, Track, FadvCommonModule } from '@fa-switch-sharedservices/ng-elements/common';
import '@fa-switch-sharedservices/web-elements/components/stepper/step-spacer';
import '@fa-switch-sharedservices/web-elements/components/stepper/step';
import '@fa-switch-sharedservices/web-elements/components/stepper/step-panel';
import '@fa-switch-sharedservices/web-elements/components/stepper/stepper';

class FadvStepPanelComponent extends FadvBaseComponent {
    constructor(el) {
        super(el);
        this.slotName = 'panel';
    }
}
FadvStepPanelComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvStepPanelComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvStepPanelComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvStepPanelComponent, selector: "fadv-step-panel", inputs: { name: "name" }, host: { properties: { "slot": "this.slotName" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvStepPanelComponent.prototype, "name", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvStepPanelComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-step-panel',
                    template: '<ng-content></ng-content>',
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { slotName: [{
                type: HostBinding,
                args: ['slot']
            }], name: [{
                type: Input
            }] } });

class FadvStepComponent extends FadvBaseComponent {
    constructor(el) {
        super(el);
        this.activeChange = new EventEmitter();
        this.visitedChange = new EventEmitter();
    }
    handleActiveChange() {
        this.activeChange.emit(this.elementRef.nativeElement.active);
    }
    handleCompletedChange() {
        this.visitedChange.emit(this.elementRef.nativeElement.completed);
    }
}
FadvStepComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvStepComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvStepComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvStepComponent, selector: "fadv-step", inputs: { label: "label", panel: "panel", active: "active", visited: "visited" }, outputs: { activeChange: "activeChange", visitedChange: "visitedChange" }, host: { listeners: { "step-active-change": "handleActiveChange()", "step-visited-change": "handleCompletedChange()" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvStepComponent.prototype, "label", void 0);
__decorate([
    Forward()
], FadvStepComponent.prototype, "panel", void 0);
__decorate([
    Forward()
], FadvStepComponent.prototype, "active", void 0);
__decorate([
    Forward()
], FadvStepComponent.prototype, "visited", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvStepComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-step',
                    template: '<ng-content></ng-content>',
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { label: [{
                type: Input
            }], panel: [{
                type: Input
            }], active: [{
                type: Input
            }], visited: [{
                type: Input
            }], activeChange: [{
                type: Output
            }], visitedChange: [{
                type: Output
            }], handleActiveChange: [{
                type: HostListener,
                args: ['step-active-change']
            }], handleCompletedChange: [{
                type: HostListener,
                args: ['step-visited-change']
            }] } });

class FadvStepperComponent extends FadvBaseComponent {
    constructor(el) {
        super(el);
        this.selectedStep = 0;
        this.linear = true;
        this.orientation = 'horizontal';
        this.labelMode = 'tooltip';
        this.stepActivated = new EventEmitter();
        this.stepDeactivated = new EventEmitter();
    }
    handleStepActivated(event) {
        this.stepActivated.emit(event.detail);
    }
    handleStepDeactivated(event) {
        this.stepDeactivated.emit(event.detail);
    }
    gotoStep(index) {
        this.elementRef.nativeElement.gotoStep(index);
    }
    nextStep() {
        this.elementRef.nativeElement.nextStep();
    }
    previousStep() {
        this.elementRef.nativeElement.previousStep();
    }
}
FadvStepperComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvStepperComponent, deps: [{ token: ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FadvStepperComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.3", type: FadvStepperComponent, selector: "fadv-stepper", inputs: { selectedStep: "selectedStep", linear: "linear", orientation: "orientation", labelMode: "labelMode", mode: "mode" }, outputs: { stepActivated: "stepActivated", stepDeactivated: "stepDeactivated" }, host: { listeners: { "stepper-step-activated": "handleStepActivated($event)", "stepper-step-deactivated": "handleStepDeactivated($event)" } }, usesInheritance: true, ngImport: i0, template: '<ng-content selector="fadv-step"></ng-content>', isInline: true });
__decorate([
    Forward()
], FadvStepperComponent.prototype, "selectedStep", void 0);
__decorate([
    Forward()
], FadvStepperComponent.prototype, "linear", void 0);
__decorate([
    Forward()
], FadvStepperComponent.prototype, "orientation", void 0);
__decorate([
    Forward()
], FadvStepperComponent.prototype, "labelMode", void 0);
__decorate([
    Forward()
], FadvStepperComponent.prototype, "mode", void 0);
__decorate([
    Track()
], FadvStepperComponent.prototype, "stepActivated", void 0);
__decorate([
    Track()
], FadvStepperComponent.prototype, "stepDeactivated", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvStepperComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fadv-stepper',
                    template: '<ng-content selector="fadv-step"></ng-content>',
                }]
        }], ctorParameters: function () {
        return [{ type: i0.ElementRef, decorators: [{
                        type: Inject,
                        args: [ElementRef]
                    }] }];
    }, propDecorators: { selectedStep: [{
                type: Input
            }], linear: [{
                type: Input
            }], orientation: [{
                type: Input
            }], labelMode: [{
                type: Input
            }], mode: [{
                type: Input
            }], stepActivated: [{
                type: Output
            }], stepDeactivated: [{
                type: Output
            }], handleStepActivated: [{
                type: HostListener,
                args: ['stepper-step-activated', ['$event']]
            }], handleStepDeactivated: [{
                type: HostListener,
                args: ['stepper-step-deactivated', ['$event']]
            }] } });

class FadvStepperModule {
}
FadvStepperModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvStepperModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FadvStepperModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.3", ngImport: i0, type: FadvStepperModule, declarations: [FadvStepperComponent, FadvStepComponent, FadvStepPanelComponent], imports: [FadvCommonModule], exports: [FadvStepperComponent, FadvStepComponent, FadvStepPanelComponent] });
FadvStepperModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvStepperModule, imports: [FadvCommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.3", ngImport: i0, type: FadvStepperModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [FadvStepperComponent, FadvStepComponent, FadvStepPanelComponent],
                    imports: [FadvCommonModule],
                    exports: [FadvStepperComponent, FadvStepComponent, FadvStepPanelComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { FadvStepComponent, FadvStepPanelComponent, FadvStepperComponent, FadvStepperModule };
